import script from "./RecipeNotes.vue?vue&type=script&lang=ts&setup=true"
export * from "./RecipeNotes.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__